import { useCompanies } from 'store/company';
import { ProjectSetupTranslationKeys, FiltersTranslationKeys } from 'intl/keys';
import { keepUndeleted } from 'shared/domain/deletable/filters';
import { companyModelToLabelledEntity } from 'shared/domain/company/mapping';
import { createEntityFilterInput } from '../common';
import { ExtendedFieldTranslationKeys } from 'intl/keys';

export const CompanyFilterInput = createEntityFilterInput({
  useData: () => {
    const { items } = useCompanies();
    return items;
  },
  transformData: (companies) =>
    companies.filter(keepUndeleted).map(companyModelToLabelledEntity),
  labelId: ProjectSetupTranslationKeys.parties,
  id: 'company-filter',
});

export const SubcontractorCompanyFilterInput = createEntityFilterInput({
  useData: () => {
    const { items } = useCompanies();
    return items;
  },
  transformData: (companies) =>
    companies.filter(keepUndeleted).map(companyModelToLabelledEntity),
  labelId: FiltersTranslationKeys.filterTypeSubcontractor,
  id: 'subcontractor-company-filter',
});

export const ExecutedByCompanyFilterInput = createEntityFilterInput({
  useData: () => {
    const { items } = useCompanies();
    return items;
  },
  transformData: (companies) =>
    companies.filter(keepUndeleted).map(companyModelToLabelledEntity),
  labelId: ExtendedFieldTranslationKeys.executedByCompanies,
  id: 'executed-by-company-filter',
});
